import type { IRole } from "./IRole";

export class RoleFunctions {
    public static sortById(role: IRole): number {
        return role.id == null ? 0 : 1;
    }
}
